// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1i_kZ","image":"Header_image__3yo54","name":"Header_name__21uZF","info":"Header_info__1r2ft","infoRow":"Header_infoRow__3PT4F"};